import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { plainToClass } from 'class-transformer';
import { RuleGroupMappingFunctionality } from './../rule-group-functionality.model';
import { RuleManagementService } from './../rule-management.service';
import { MessageService } from './../../../services/messages.service';
import { SnackBarService } from './../../../services/snackbar.service';
import { TrackingService } from '../../../shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from './../../../shared/services/tracking/tracking-constants.service';
import { AddRuleGroupMappingComponent } from '../addrulegroupmapping/add-rulegroupmapping.component';

@Component({
    selector: 'rulegroupmapping-list',
    templateUrl: './rulegroupmapping-list.component.html',
    styleUrls: ['./rulegroupmapping-list.component.css']
})

/**
 * Component for display the rule group mapping list.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export class RuleGroupMappingListComponent implements OnInit {
    rulegroupmapping: RuleGroupMappingFunctionality[];
    dialogRef: MdDialogRef<any>;
    selectedRuleGroupMapping: RuleGroupMappingFunctionality;
    isLoading = true;

    constructor(
        public dialog: MdDialog,
        public viewContainerRef: ViewContainerRef,
        private ruleManagementService: RuleManagementService,
        private trackingService: TrackingService,
        private snackBarService: SnackBarService,
    ) { }

    ngOnInit() {
        this.getRuleGroupMappingList();
    }

    getRuleGroupMappingList() {
        this.ruleManagementService.getRuleGroupMappingFunctionality()
            .subscribe(response => {
                this.rulegroupmapping = response;
                this.isLoading = false;
            });
    }

    openAddRuleGroupMappingDialog(action: string) {
        let config = new MdDialogConfig();
        config.viewContainerRef = this.viewContainerRef;
        this.dialogRef = this.dialog.open(AddRuleGroupMappingComponent, config);
        this.dialogRef.componentInstance.selectedRuleGroupMapping = this.selectedRuleGroupMapping;
        this.dialogRef.componentInstance.action = action;
        this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef = null;
            if (result) {
                this.updateRuleGroupMappingList(result, action);
            }
            this.selectedRuleGroupMapping = null;
        });
    }

    updateRuleGroupMappingList(formResponse: RuleGroupMappingFunctionality, action: string) {
        if (action === 'Edit') {
            this.rulegroupmapping.splice(this.rulegroupmapping.indexOf(this.selectedRuleGroupMapping), 1);
        }
        this.rulegroupmapping.push(formResponse);
    }

    editRuleGroupMapping(value: RuleGroupMappingFunctionality): void {
        this.selectedRuleGroupMapping = value
        this.openAddRuleGroupMappingDialog('Edit');
    }

    deleteRuleGroupMapping(value: RuleGroupMappingFunctionality): void {
        if (confirm(MessageService.DELETE_RULE_GROUP_FUNCTIONALITY_ALERT)) {
            this.ruleManagementService.deleteRuleGroupFunctionality(value.id)
                .subscribe(response => {
                    if (response.flagResult) {
                        this.rulegroupmapping.splice(this.rulegroupmapping.indexOf(value), 1);
                    }
                    this.trackingService
                        .emitEvent(
                        TrackingConstants.RULE_MANAGEMENT,
                        TrackingConstants.DELETE_RULE_GROUP_FUNCTIONALOITY,
                        TrackingConstants.SUCCESS, 1);
                    this.callSnackBarService(response,
                        MessageService.DELETE_RULE_GROUP_FUNCTIONALITY_SUCCESS, MessageService.DELETE_RULE_GROUP_FUNCTIONALITY_FAILURE);
                },
                err => {
                    this.trackingService
                        .emitEvent(
                        TrackingConstants.RULE_MANAGEMENT,
                        TrackingConstants.DELETE_RULE_GROUP_FUNCTIONALOITY,
                        TrackingConstants.FAILURE, 0);
                    this.callSnackBarService(err,
                        MessageService.DELETE_RULE_GROUP_FUNCTIONALITY_SUCCESS,
                        MessageService.DELETE_RULE_GROUP_FUNCTIONALITY_FAILURE);
                });
        }
    }

    callSnackBarService(response: any, successMsg: string, failureMsg: string) {
        this.snackBarService.showStatus(response, successMsg, failureMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/rules/rulegroupmappinglist/rulegroupmapping-list.component.ts